import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-copy-icon',
  templateUrl: 'copy-icon.component.html'
})
export class CopyIconComponent {
  constructor() {}
}
